import { Component, OnInit } from '@angular/core';
import { SignupService } from '../../services/signup.service';
import { ActivatedRoute } from '@angular/router';
import { WatcherService } from 'src/app/services/watcher.service';
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/store/app.reducer';
@Component({
    selector: 'app-shop-from',
    templateUrl: './shop-from.component.html',
    styleUrls: ['./shop-from.component.css']
})
export class ShopFromComponent implements OnInit {
    loggedUser;
    hostCountries;
    constructor(
        public signUpService: SignupService,
        private route: ActivatedRoute,
        private watcherService: WatcherService,
        private store: Store<AppState>,
    ) {
        this.signUpService.getHostCountries().subscribe(list => {
            this.hostCountries = list["data"];
        })

    }
    lang;
    ngOnInit(): void {
        this.store.select('auth').subscribe(state => {
            this.loggedUser = state.user ?? null;
          })
        window.scrollTo(0,0)
        this.watcherService.getLang().subscribe(
            lang => {
                this.lang = lang;
            }
        )
    }

}
